import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModulewisePageComponent } from './modulewise-page/modulewise-page.component';
import { PagewiseActionComponent } from './pagewise-action/pagewise-action.component';
import { ModuleRoleManagementComponent } from './module-role-management/module-role-management.component';
import { CreateUserInfoComponent } from './create-user-info/create-user-info.component';
import { UserListComponent } from './user-list/user-list.component';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: 'module-page',
    component: ModulewisePageComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'page-action',
    component: PagewiseActionComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'module-role',
    component: ModuleRoleManagementComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'create-user',
    component: CreateUserInfoComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'user-list',
    component: UserListComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'edit-user/:id',
    component: CreateUserInfoComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }
